export const ALLOWED_PATH = {
  BASE: '/',
  ATTACHMENT: '/attachment',
  REMUNERATION: '/remuneration',
}
